import * as React from "react";
import { useFormContext } from "react-hook-form";
import { useDebounce } from "../../../components/table/useDebounce";
import { request, resourceLink } from "../../../services/cpln";
import { Gvc } from "../../../schema/types/gvc";
import { DomainInput } from "./types/input";

// TODO move to syncer
export const CreateNGTrackGVCAlias: React.FC = () => {
  const { watch, getValues, setValue } = useFormContext<DomainInput>();

  const gvcName = watch("gvc.name");
  const [debouncedGvcName, setDebouncedGvcName] = useDebounce(gvcName, 300);

  React.useEffect(() => {
    setDebouncedGvcName(gvcName);
  }, [gvcName]);
  React.useEffect(() => {
    updateGvcAlias();
  }, [debouncedGvcName]);

  async function updateGvcAlias() {
    const v = getValues();
    if (gvcName && !v.gvc.alias) {
      try {
        const { data } = await request<Gvc>({ url: resourceLink("gvc", gvcName) });
        setValue("gvc.alias", data.alias || "");
      } catch (e) {}
    }
  }

  return null; // This is a logic-only component
};
